// import fa from 'element-ui/src/locale/lang/fa'

import moment from 'moment'

export function getObjString (data) {
  if (data === undefined || data === null || data === '') {
    return ''
  }
  return data
}

export function deviceStatusFormat (device, item) {
  if (device === undefined) {
    return ''
  }
  let status
  switch (item) {
    case 'engine':
      if (objIsNotNull(device.status) && objIsNotNull(device.status.engineStatus)) {
        status = device.status.engineStatus
      }
      break
    case 'airCondition':
      if (objIsNotNull(device.status) && objIsNotNull(device.status.airConditionStatus)) {
        status = device.status.airConditionStatus
      }
      break
    case 'door':
      if (objIsNotNull(device.status) && objIsNotNull(device.status.doorStatus)) {
        status = device.status.doorStatus
      }
      break
    case 'headlight':
      if (objIsNotNull(device.status) && objIsNotNull(device.status.headlightStatus)) {
        status = device.status.headlightStatus
      }
      break
    case 'movement':
      if (objIsNotNull(device.status) && objIsNotNull(device.status.movementStatus)) {
        status = device.status.movementStatus
      }
      break
    default:
  }
  if (status === undefined) {
    return ''
  } else if (status === 1) {
    return 'ON'
  } else {
    return 'OFF'
  }
}

export function objIsNull (obj) {
  if (obj === undefined || obj === null || obj === '') {
    return true
  } else {
    return false
  }
}

export function objIsNotNull (obj) {
  return !objIsNull(obj)
}

/**
 * 将时间戳转换为字符串
 * @param {Date} date 日期
 * @param {String} formatStr 自定义时间格式，默认'yyyy/MM/DD HH:mm:ss'
 * @returns DateString
 */
export function convertDateTimeToString (date, formatStr) {
  if (formatStr) {
    return moment(date).format(formatStr)
  } else {
    return moment(date).format('yyyy/MM/DD HH:mm:ss')
  }
}

export function searchFromList(list, str, func) {
  if (!str){
    return false
  }
  if (! (list instanceof Array)){
    return false
  }

  if (list && list.length > 0) {
    for(let i=0;i<list.length;i++){
      if (func(list[i],str)) {
        return true
      }
    }
  }
  return false
}

export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}
